import {makeObservable, observable, action} from 'mobx';

/**
 * ConfirmDialogStore - 管理所有确认弹窗的显示状态
 *
 * 职责:
 * - 管理"进入下一阶段"确认弹窗 (showSolutionModal)
 * - 管理"任务配置"页面显示状态 (showJobConfigPage)
 * - 管理"暂停任务"确认弹窗 (pauseModalVisible)
 * - 管理"终止任务"确认弹窗 (terminateModalVisible)
 * - 管理"重启演化"两步弹窗流程 (evolveRestartModalVisible, evolveParamsModalVisible)
 *
 * 设计原则:
 * - 单一职责: 只管理 UI 弹窗状态
 * - 无业务逻辑: 不处理任务执行逻辑
 * - 状态独立: 与任务执行状态解耦
 */
export class ConfirmDialogStore {
    /** 进入下一阶段确认弹窗 */
    showSolutionModal: boolean = false;

    /** 任务配置页面显示状态 */
    showJobConfigPage: boolean = false;

    /** 暂停任务确认弹窗 */
    pauseModalVisible: boolean = false;

    /** 终止任务确认弹窗 */
    terminateModalVisible: boolean = false;

    /** 进入报告阶段确认弹窗 */
    showReportingModal: boolean = false;

    /** 重启演化 - 方式选择弹窗 */
    evolveRestartModalVisible: boolean = false;

    /** 重启演化 - 参数配置弹窗 */
    evolveParamsModalVisible: boolean = false;

    /** 演化参数配置 */
    evolveParams: {iterations: number} = {iterations: 30};

    constructor() {
        makeObservable(this, {
            showSolutionModal: observable,
            showJobConfigPage: observable,
            pauseModalVisible: observable,
            terminateModalVisible: observable,
            showReportingModal: observable,
            evolveRestartModalVisible: observable,
            evolveParamsModalVisible: observable,
            evolveParams: observable,
            setShowSolutionModal: action.bound,
            setShowJobConfigPage: action.bound,
            setPauseModalVisible: action.bound,
            setTerminateModalVisible: action.bound,
            setEvolveParamsModalVisible: action.bound,
            reset: action.bound,
            closeAll: action.bound
        });
    }

    /** 设置"进入下一阶段"弹窗状态 */
    setShowSolutionModal(visible: boolean) {
        this.showSolutionModal = visible;
    }

    /** 设置"任务配置"页面显示状态 */
    setShowJobConfigPage(visible: boolean) {
        this.showJobConfigPage = visible;
    }

    /** 设置"暂停任务"弹窗状态 */
    setPauseModalVisible(visible: boolean) {
        this.pauseModalVisible = visible;
    }

    /** 设置"终止任务"弹窗状态 */
    setTerminateModalVisible(visible: boolean) {
        this.terminateModalVisible = visible;
    }

    /** 设置"重启演化-参数配置"弹窗状态 */
    setEvolveParamsModalVisible(visible: boolean) {
        this.evolveParamsModalVisible = visible;
    }

    /** 重置所有弹窗状态 */
    reset() {
        this.showSolutionModal = false;
        this.showJobConfigPage = false;
        this.pauseModalVisible = false;
        this.terminateModalVisible = false;
        this.showReportingModal = false;
        this.evolveRestartModalVisible = false;
        this.evolveParamsModalVisible = false;
    }

    /** 关闭所有弹窗 */
    closeAll() {
        this.reset();
    }
}
